var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"adm-layout",style:(_vm.layoutBgStyle)},[_c('AdminSidebar'),_c('el-container',{staticClass:"adm-layout__main-wrap",attrs:{"direction":"vertical"}},[_c('AdminHeader'),_c('el-main',{staticClass:"adm-layout__main"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }